// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__fGGbz","title":"Images45_title__1_48W","images":"Images45_images__1CRzb"};